import { SxProps, Theme } from '@mui/material/styles';

export const stickNameCell = (minWidth = '300px'): SxProps<Theme> => ({
  minWidth,
  position: 'sticky',
  left: 0,
  backgroundColor: 'background.paper',
});
